/* EKOHUM product galleries: quiet dot progress; homepage mobile cards auto-advance. */
(function(){
 if(window.__ascCardGalleryBound)return;
 window.__ascCardGalleryBound=true;
 var hideTimers=new WeakMap();
 function reveal(media){
  if(!media)return;
  media.classList.add('is-interacting');
  if(hideTimers.has(media))clearTimeout(hideTimers.get(media));
  hideTimers.set(media,setTimeout(function(){media.classList.remove('is-interacting');hideTimers.delete(media);},1800));
 }
 function update(gallery){
  if(!gallery||!gallery.clientWidth)return;
  var slides=gallery.querySelectorAll('.asc-card-gallery-slide');
  if(!slides.length)return;
  var media=gallery.closest('.asc-card-media');
  if(!media)return;
  var index=Math.max(0,Math.min(slides.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth)));
  var count=media.querySelector('[data-asc-gallery-count]');
  if(count){
   if(!count.dataset.ascDotsReady){
    count.textContent='';
    for(var i=0;i<slides.length;i++){
     var dot=document.createElement('span');dot.className='asc-card-gallery-dot';dot.setAttribute('aria-hidden','true');count.appendChild(dot);
    }
    count.dataset.ascDotsReady='true';count.setAttribute('role','img');
   }
   count.setAttribute('aria-label','Photo '+(index+1)+' of '+slides.length);
   count.querySelectorAll('.asc-card-gallery-dot').forEach(function(dot,i){dot.classList.toggle('is-active',i===index);});
  }
  var prev=media.querySelector('[data-asc-gallery-prev]');
  var next=media.querySelector('[data-asc-gallery-next]');
  if(prev)prev.disabled=index===0;
  if(next)next.disabled=index===slides.length-1;
 }
 function initialize(){document.querySelectorAll('[data-asc-card-gallery]').forEach(update);}
 document.addEventListener('pointerdown',function(event){
  var gallery=event.target.closest&&event.target.closest('[data-asc-card-gallery]');
  if(gallery)reveal(gallery.closest('.asc-card-media'));
 },{passive:true});
 document.addEventListener('click',function(event){
  var button=event.target.closest&&event.target.closest('[data-asc-gallery-prev],[data-asc-gallery-next]');
  if(!button)return;
  var media=button.closest('.asc-card-media');
  var gallery=media&&media.querySelector('[data-asc-card-gallery]');
  if(!gallery||!gallery.clientWidth)return;
  event.preventDefault();reveal(media);
  var slides=gallery.querySelectorAll('.asc-card-gallery-slide');
  var current=Math.round(gallery.scrollLeft/gallery.clientWidth);
  var step=button.hasAttribute('data-asc-gallery-next')?1:-1;
  var target=Math.max(0,Math.min(slides.length-1,current+step));
  gallery.scrollTo({left:target*gallery.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  var prev=media.querySelector('[data-asc-gallery-prev]');var next=media.querySelector('[data-asc-gallery-next]');
  if(prev)prev.disabled=target===0;if(next)next.disabled=target===slides.length-1;
 });
 document.addEventListener('scroll',function(event){
  var gallery=event.target;
  if(gallery&&gallery.matches&&gallery.matches('[data-asc-card-gallery]')){
   update(gallery);
   if(!gallery.closest('.asc-home-section'))reveal(gallery.closest('.asc-card-media'));
  }
 },true);
 window.addEventListener('resize',initialize);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
 if(window.MutationObserver){
  var observer=new MutationObserver(function(mutations){
   for(var i=0;i<mutations.length;i++){
    var nodes=mutations[i].addedNodes;
    for(var j=0;j<nodes.length;j++){
     var node=nodes[j];
     if(node.nodeType===1&&(node.matches&&node.matches('[data-asc-card-gallery]')||node.querySelector&&node.querySelector('[data-asc-card-gallery]'))){initialize();return;}
    }
   }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
 }
})();

